import { render, staticRenderFns } from "./AvatarWith3Lines.vue?vue&type=template&id=174bae9c&"
import script from "./AvatarWith3Lines.vue?vue&type=script&lang=js&"
export * from "./AvatarWith3Lines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports